export default {
  subdomain: 'maif',
  sso: {
    protocol: 'openIDConnect',
    login: 'https://opb2e.maif.fr/as/authorization.oauth2?client_id=prod_bubbleplan&response_type=code&scope=openid%20email%20profile&redirect_uri=https%3A%2F%2Fmaif.bubbleplan.net',
    response_type: 'code',
  },
  hideManageAccount: true,
};
